// Browser-facing admin console path. Configurable so the console doesn't sit at
// a guessable URL. Set REACT_APP_ADMIN_PATH at BUILD time (Create React App
// inlines REACT_APP_* vars into the bundle); defaults to '/admin'.
//
// This obscures only the SPA route the admin navigates to. The JSON API stays
// at /api/admin/* -- those endpoints do their own auth (allow-list + 2FA) and
// brute-force rate limiting, so they don't rely on path secrecy.
const normalize = raw => {
	const s = String(raw || '').trim();
	if (!s) return '/admin';
	const withLead = s.startsWith('/') ? s : `/${s}`;
	// Strip trailing slashes (but keep a lone "/").
	return withLead.length > 1 ? withLead.replace(/\/+$/, '') : withLead;
};

export const ADMIN_PATH = normalize(process.env.REACT_APP_ADMIN_PATH);
export const ADMIN_LOGIN_PATH = `${ADMIN_PATH}/login`;
